import * as React from 'react';
import { IContainerProps } from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './ForkedRibbonArea.scss';

const ForkedRibbonArea: React.FC<IContainerProps> = props => {
  return (
    <ContainerLogic
      {...props}
      className={styles.root}
      renderSlot={({ containerChildren }) => (
        <>
          <b className={styles.top} />
          <b className={styles.bot} />
          <b className={styles.ctr} />
          <div className={styles.bg} />
          {containerChildren}
        </>
      )}
    />
  );
};

export default ForkedRibbonArea;
